import { Component, inject, signal } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { TuiButton } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import type { TuiDialogContext } from '@taiga-ui/core';

@Component({
  selector: 'app-support-dialog',
  imports: [TuiButton],
  template: `
    <p>Email us at <strong>{{ supportEmail }}</strong>.</p>
    <p>Copy the address into your webmail, or open your email app.</p>
    <div class="flex flex-wrap gap-2">
      <button type="button" tuiButton (click)="copySupportEmail()">Copy</button>
      <a tuiButton appearance="secondary" [href]="'mailto:' + supportEmail">Open email app</a>
    </div>
    <p role="status">{{ supportCopyStatus() }}</p>
  `,
})
export class SupportDialogComponent {
  private readonly clipboard = inject(Clipboard);
  private readonly context = inject<TuiDialogContext<void>>(POLYMORPHEUS_CONTEXT);

  readonly supportEmail = 'support@reverbreports.com';
  readonly supportCopyStatus = signal('');

  copySupportEmail(): void {
    this.supportCopyStatus.set(
      this.clipboard.copy(this.supportEmail)
        ? 'Email address copied.'
        : 'Could not copy. Please select and copy the email address above.',
    );
  }
}
